import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import './referenceFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Options } from '../Options/options';
import { ReferenceInput } from '../RefereceInput/referenceInput';

const OPTIONS = [Op.refIds, Op.notRefIds, Op.isEmpty, Op.isNotEmpty];
const isSameType = (op1: Op, op2: Op) => {
  if (
    [Op.refIds, Op.notRefIds].includes(op1) &&
    [Op.refIds, Op.notRefIds].includes(op2)
  ) {
    return true;
  }
  return false;
};

type RefFilterProps = FilterProps & {
  inlineMenu?: boolean;
  singleValue?: boolean;
};

export const SingleValueReferenceFilter = (p: RefFilterProps) => (
  <ReferenceFilter {...p} singleValue={true} />
);

export const ReferenceFilter = ({
  filter,
  field,
  setFilter,
  cache,
  opts,
  filters,
  preappliedFilters,
  singleValue,
  inlineMenu = true
}: RefFilterProps) => {
  const curFilter = filter; //findOne(filters, { field: filter.field });
  if (singleValue) opts = [Op.refIds];
  else if (!opts) opts = OPTIONS;
  const { op, val } = parseCondition(curFilter.conditions, opts[0]);
  const showInput = op != Op.isEmpty && op != Op.isNotEmpty;

  return (
    <div className="filter-box reference-filter tree-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={opts}
          onSelect={o => {
            if ([Op.isEmpty, Op.isNotEmpty].includes(o)) {
              setFilter({ ...curFilter, conditions: [{ [o]: true }] });
            } else {
              if (isSameType(op, o)) {
                setFilter({ ...curFilter, conditions: [{ [o]: val }] });
              } else {
                setFilter({ ...curFilter, conditions: [{ [o]: null }] });
              }
            }
          }}
          disabled={!!singleValue}
          selected={op}
        />
      </div>
      <div>
        {showInput && (
          <ReferenceInput
            selected={val}
            nodeType={field.dataType}
            inlineMenu={inlineMenu}
            singleValue={singleValue}
            cache={cache}
            schemaField={field}
            field={filter.field}
            filters={filters}
            preappliedFilters={preappliedFilters}
            onChange={values => {
              setFilter({ ...curFilter, conditions: [{ [op]: values }] }, true);
            }}
          />
        )}
      </div>
    </div>
  );
};
